<template>
    <div v-if="this.data == 1" class="alert_container">
        <div class="alert">
            <lottie-player src="https://assets10.lottiefiles.com/packages/lf20_jcex9dky.json" background="transparent" speed="1" style="width: 40px; height: 40px; margin-right: 10px;" loop autoplay></lottie-player>
            {{$t('changelog.alert_1',{version: json[0].version})}}
            <a href="/admin/changelog" @click="remove">{{ $t('changelog.alert_2') }}</a>
            <span class="closebtn" @click="remove">&times;</span>
        </div>
    </div>
</template>

<script>
import json from '../../admin/changelog/changelog.json'
    export default {
        props: ['user'],
        data() {
            return {
                json: json.changelogs,
                data: 0
            }
        },
        created () {
            this.data = this.user.changelog
        },
        methods: {
            remove(){
                this.data = 0;
                axios.post(`/api/newVersion`, {data:this.data}).then(response => {})
            }
        },
          mounted() {
            let externalScript = document.createElement('script')
            externalScript.setAttribute('src', 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js')
            document.head.appendChild(externalScript)
        },
    }
</script>

<style lang="scss" scoped>

@keyframes myfirst {
  0%   {transform: translateY(-100px)}
  100% {transform: translateY(40px)}
}
.alert_container{    
    animation: myfirst 1s forwards 1;
    z-index: 10000;
    position: fixed;
    display: flex;
    justify-content: center;
    left: 0;
    right: 0;
    width: fit-content;
    margin: auto;
}
/* The alert message box */
.alert {    
    display: flex;
    align-items: center;    
    padding: 15px 30px;
    background: linear-gradient(0deg, #212541, #212541), #FFFFFF;
    color: white;
    margin-bottom: 15px;
    box-shadow: 0px 0px 8px rgb(51 51 51 / 50%);
        font-weight: 600;
    font-size: 15px;
    font-family: Montserrat;
    font-style: normal;
}

/* The close button */
.closebtn {
    color: white;
    font-weight: bold;
    float: right;
    font-size: 27px;
    line-height: 20px;
    cursor: pointer;
    transition: 0.3s;
    margin-left: 16px;
}

/* When moving the mouse over the close button */
.closebtn:hover {
  color: #F93C34;
}
a{
        font-weight: 600;
    font-size: 15px;
    font-family: Montserrat;
    font-style: normal;
    margin-left: 6px;
    color: white;
    text-decoration: underline;
    &:hover{
        color: #F93C34;
    }
}
</style>